<template>
  <div class="row">
    <div class="col-12">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div class="card-body p-10">
          <ul class="settings-tabs ps-0 mb-0 list-unstyled">
            <li>
              <router-link
                to="/account-settings"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              >
                Account Settings
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-statuts"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Status
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-type-clients"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Types des clients
              </router-link>
            </li>
            <li>
              <router-link
                to="/settings-banks"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Liste des banques
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-social-links"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
                >Lien social
              </router-link>
            </li>

            <li>
              <router-link
                to="/settings-transports"
                class="fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              >
                Transports
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card"
      >
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
          <div class="row">
            <div class="col-12 mb-40">
              <form @submit.prevent="submitForm">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Nom du transport
                      </label>
                      <input
                        type="text"
                        class="form-control shadow-none rounded-0 text-black"
                        v-model="transport.name"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Code du transport
                      </label>
                      <input
                        type="text"
                        class="form-control shadow-none rounded-0 text-black"
                        v-model="transport.code_transport"
                      />
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                       Type du transport
                      </label>
                      <select
                        class="form-select shadow-none rounded-0 text-black"
                        v-model="transport.type"
                      >
                        <option selected disabled value="">Choisir le type</option>
                        <option value="1">Interne</option>
                        <option value="2">Externe</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <button
                        class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                        type="submit"
                        style="float: right"
                      >
                        Enregistrer
                      </button>
                      <!-- <button
                        type="button"
                        class="bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                    >
                        <i
                        class="flaticon-delete lh-1 me-1 position-relative top-2"
                        ></i>
                        <span class="position-relative">Cancel</span>
                    </button> -->
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <hr />
            <div class="col-12 mt-20">
              <h5 class="fs-16 fw-semibold mb-20">Liste des transports</h5>
              <EasyDataTable
                :headers="headers"
                :items="transports"
                buttons-pagination
              >
                <template #item-actions="{ id }">
                  <div class="dropdown">
                    <button
                      class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="flaticon-dots"></i>
                    </button>
                    <ul class="dropdown-menu">
                      <li>
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="javascript:void(0);"
                          @click="openEditModal(id)"
                        >
                          <i
                            class="flaticon-pen lh-1 me-8 position-relative top-1"
                          ></i>
                          Modifier
                        </a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="javascript:void(0);"
                          @click="deleteType(id)"
                        >
                          <i
                            class="flaticon-delete lh-1 me-8 position-relative top-1"
                          ></i>
                          Supprimer
                        </a>
                      </li>
                    </ul>
                  </div>
                </template>
              </EasyDataTable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 🧩 Edit Modal -->
  <div
    class="modal fade"
    id="editTransportModal"
    tabindex="-1"
    aria-labelledby="editTransportModalLabel"
    aria-hidden="true"
    ref="editModal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="editTransportModalLabel">
            Modifier le transport
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label">Nom du transport</label>
            <input
              v-model="editTransport.name"
              type="text"
              class="form-control"
              placeholder="Nom du transport"
            />
          </div>
          <div class="mb-3">
            <label class="form-label">Code du transport</label>
            <input
              v-model="editTransport.code_transport"
              type="text"
              class="form-control"
              placeholder="Code du transport"
            />
          </div>
          <!-- <div class="mb-3">
            <label class="form-label">Code de la banque</label>
            <input
              v-model="editTransport.code"
              type="text"
              class="form-control"
              placeholder="Code de la banque"
            />
          </div> -->
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Fermer
          </button>
          <button type="button" class="btn btn-primary" @click="updateBank">
            Sauvegarder
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from "vue";
import BlotFormatter from "quill-blot-formatter";
import ImageUploader from "quill-image-uploader";
import axios from "axios";
import api from "@/utils/axios";
// import Select2 from "@/components/Select2.vue";
import { useAppToast } from "@/composables/useAppToast";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";

export default defineComponent({
  name: "AccountSettings",
  //  components :{ Select2 },

  setup: () => {
    const { showToast } = useAppToast();
    const transports = ref([]);

    const headers = [
      { text: "Code", value: "code_transport" },
      { text: "Nom", value: "name" },
      { text: "Bons d'envoie", value: "bons" },
      { text: "Bons Retour", value: "bonsRN" },
      { text: "Actions", value: "actions" },
    ];

    const transport = reactive({
      name: "",
      code_transport: "",
      type: "",
      fees: "",
    });

    onMounted(async () => {
      fetchtransports();
    });

    async function fetchtransports() {
      try {
        const response = await api.get("/api/auth/AllTransport");
        if (response && response.data) {
          // handle the fetched cities data
          // console.log("Fetched cities:", response.data);
          transports.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    }

    // Submit form
    async function submitForm() {
      try {
        const formData = new FormData();
        formData.append("name", transport.name);
        formData.append('type', transport.type);
        formData.append('code_transport', transport.code_transport);
        formData.append('fees', transport.fees);

        const response = await api.post("/api/auth/NewTransport", formData);

        if (response.data.message == "success") {
          fetchtransports(); // Refresh the status list
          // Clear the form
          transport.name = "";
          transport.code_transport = "";
          transport.type = "";
          transport.fees = "";
          showToast("Settings saved successfully!", "success");
        } else {
          showToast("Error: " + response.data.message, "error");
        }
      } catch (error) {
        console.error(error);
        showToast("An error occurred while saving settings.", "error");
      }
    }
    function deleteType(id) {
      Swal.fire({
        text: "Vous voulez supprimer ce colis ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      }).then(async (result: any) => {
        if (result.isConfirmed) {
          const data = new FormData();
          try {
            const res = await api.post(`/api/auth/removeBank/${id}`);
            if (res.data.success) {
              showToast("Banque supprimée avec succès", "success");
              fetchtransports();
            } else {
              showToast(
                res.data.message ?? "Vous ne pouvez pas supprimer cette banque",
                "error"
              );
            }
          } catch (error) {
            showToast("Erreur lors de la suppression de la banque", "error");
          }
        }
      });
    }

    const editTransport = ref({ id: null, name: "", code_transport: "" , fees: "", type: "" });
    const editModal = ref(null);
    let modalInstance = null;

    const openEditModal = (id) => {
      // Find the bank data by id
      const bank = transports.value.find((b) => b.id === id);
      if (bank) {
        editTransport.value = { ...bank };
        if (!modalInstance) {
          modalInstance = new Modal(editModal.value);
        }
        modalInstance.show();
      }
    };

    const updateBank = async () => {
      // Example: make your API call here
      try {
        let data = new FormData;
          data.append('name', editTransport.value.name);
          data.append('code_transport', editTransport.value.code_transport);
          data.append('fees', editTransport.value.fees);
          data.append('type', editTransport.value.type);
        const res = await api.post(
          `/api/auth/trans_edit/${editTransport.value.id}`,
          data
        );
        if(res.data.success){
          modalInstance.hide();
          fetchtransports();
        } else {
          showToast(res.data.message ?? "Erreur lors de la mise à jour", "error");
          return;
        }    
      } catch (error) {
        console.error(error);
        showToast("Erreur lors de la mise à jour", "error");
      }
    };

    return {
      transports,
      headers,
      submitForm,
      transport,
      deleteType,
      editTransport,
      editModal,
      openEditModal,
      updateBank,
    };
  },
});
</script>